import { MarkerType } from '@xyflow/react';
import type { FlowEdge } from '../types/flowchart.types';
import type { EdgeProperties } from '../editor/PropertiesPanel';

export function applyEdgeProperties(edge: FlowEdge, props: EdgeProperties): FlowEdge {
  const updated = { ...edge };

  if (props.label !== undefined) {
    updated.label = props.label || undefined;
  }

  const style = { ...((updated.style as Record<string, unknown>) ?? {}) };

  if (props.lineStyle) {
    switch (props.lineStyle) {
      case 'dashed':
        style.strokeDasharray = '6 3';
        break;
      case 'dotted':
        style.strokeDasharray = '2 2';
        break;
      default:
        delete style.strokeDasharray;
        break;
    }
  }

  if (props.color) {
    style.stroke = props.color;
  }

  if (props.arrowType) {
    const color = props.color || (style.stroke as string) || '#5A6A7A';
    switch (props.arrowType) {
      case 'none':
        updated.markerEnd = undefined;
        updated.markerStart = undefined;
        break;
      case 'bidirectional':
        updated.markerEnd = { type: MarkerType.ArrowClosed, color, width: 12, height: 12 };
        updated.markerStart = { type: MarkerType.ArrowClosed, color, width: 12, height: 12 };
        break;
      case 'open':
        updated.markerEnd = { type: MarkerType.Arrow, color, width: 12, height: 12 };
        updated.markerStart = undefined;
        break;
      default:
        updated.markerEnd = { type: MarkerType.ArrowClosed, color, width: 12, height: 12 };
        updated.markerStart = undefined;
        break;
    }
  }

  const edgeData = { ...((updated.data as Record<string, unknown>) ?? {}) };
  if (props.lineStyle) edgeData.lineStyle = props.lineStyle;
  if (props.arrowType) edgeData.arrowType = props.arrowType;
  if (props.color) edgeData.color = props.color;
  updated.data = edgeData;

  updated.style = style;
  return updated;
}
